function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import Button from "./Button";
import Spacer from "noood/comp/ui/spacer/Spacer";
export default function AddOrEditButton(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    set_errors = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    success = _useState4[0],
    set_success = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    processing = _useState6[0],
    set_processing = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    valid = _useState8[0],
    set_valid = _useState8[1];
  useEffect(function () {
    set_processing(props.processing ? true : undefined);
  }, [props.processing]);
  useEffect(function () {
    set_valid(props.valid);
  }, [props.valid]);
  return /*#__PURE__*/React.createElement("div", null, props.isSubmit && /*#__PURE__*/React.createElement(Spacer, {
    mtop: 15
  }), /*#__PURE__*/React.createElement(Button, {
    primary: true,
    icon: props.edit ? "save" : "plus",
    loading: processing,
    disabled: processing || !valid,
    label: props.edit ? "Update ".concat(props.obj) : "Add ".concat(props.obj),
    __click: function __click() {
      var _props$__click;
      (_props$__click = props.__click) === null || _props$__click === void 0 || _props$__click.call(props);
    },
    medium: props.size === 'M'
  }));
}
AddOrEditButton.propTypes = {
  obj: PropTypes.string.isRequired,
  processing: PropTypes.bool,
  edit: PropTypes.bool,
  valid: PropTypes.bool,
  __click: PropTypes.func,
  style: PropTypes.object,
  size: PropTypes.oneOf(['S', 'R', 'M', 'L', 'XL']),
  isSubmit: PropTypes.bool
};
AddOrEditButton.defaultProps = {
  edit: undefined
};